<template>
  <ui-aside-layout @close="$emit('close')" class="sidebar-ui-bubble">
    <template slot="title">Combine a bubble</template>
    <template slot="description">Create your own bubble or use an existing bubble</template>

    <template slot="content">
      <div class="mt-4 mb-4">
        <p>Bubbles available :</p>
        <select
          v-model="bubbleChoosed"
          class="p-3 mb-2 w-full cursor-pointer placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline">
          <option v-for="bubble in bubblesAvailable" :key="bubble.id" :value="bubble.id">{{ bubble.name }}</option>
        </select>

        <div class="text-right">
          <common-button @click="next()" type="primary">Next</common-button>
        </div>

        <div class="absolute bottom-0 left-0 text-center w-full pb-10">
          <common-button @click="createBubble()" type="secondary">Create a bubble</common-button>
        </div>

      </div>
    </template>

  </ui-aside-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'BannersUiSidebarBubbleSelector',

  props: {
    excludedBubbles: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  components: {
  },
  data () {
    return {
      bubbleChoosed: null
    }
  },
  computed: {
    ...mapState('bubbles', {
      bubbles: 'items'
    }),
    bubblesAvailable () {
      return this.bubbles.filter(b => !this.excludedBubbles.includes(b.id))
    }
  },
  methods: {
    ...mapActions('bubbles', ['loadBubbles']),

    createBubble () {
      this.bubbleChoosed = null
      this.next()
    },

    next () {
      if (this.bubbleChoosed) {
        this.$emit('bubble', this.bubbleChoosed)
      } else {
        this.$emit('bubble', null)
      }
    }
  },

  mounted () {
    this.loadBubbles()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/banners/ui/sidebar/bubble-selector.vue